import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "compose__send",
  "use": "compose__send-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"compose__send\">\n  <path fill-rule=\"evenodd\" d=\"M18.831 9.934 1.711 17.27a1 1 0 0 1-1.314-.525 1 1 0 0 1-.079-.454l.393-6.49h6.997c.5 0 .913-.374.974-.858l.007-.123a.982.982 0 0 0-.981-.982H.69l-.52-5.91A1 1 0 0 1 1.08.844a1 1 0 0 1 .47.072l17.27 7.174a1 1 0 0 1 .011 1.843Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol